var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnattendedLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97905 7.92343V9.17269C5.605 9.0405 5.20255 8.96857 4.78324 8.96857C2.80195 8.96857 1.19581 10.5747 1.19581 12.556H0C0 9.91427 2.14153 7.77276 4.78324 7.77276C5.19615 7.77276 5.59687 7.82508 5.97905 7.92343ZM4.78324 7.17485C2.80118 7.17485 1.19581 5.56948 1.19581 3.58743C1.19581 1.60537 2.80118 0 4.78324 0C6.76529 0 8.37066 1.60537 8.37066 3.58743C8.37066 5.56948 6.76529 7.17485 4.78324 7.17485ZM4.78324 5.97905C6.10461 5.97905 7.17485 4.9088 7.17485 3.58743C7.17485 2.26606 6.10461 1.19581 4.78324 1.19581C3.46187 1.19581 2.39162 2.26606 2.39162 3.58743C2.39162 4.9088 3.46187 5.97905 4.78324 5.97905ZM8.24684 11.3089L10.3607 9.19499L11.2063 10.0406L8.24684 13L6.13295 10.8861L6.9785 10.0406L8.24684 11.3089Z",
    fill: "#7E8392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnattendedLive);
export default __webpack_public_path__ + "static/media/unattended-live.6f23a400b75fceb50f372c4952b2adfd.svg";
export { ForwardRef as ReactComponent };